import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/kontakt" as const,
	[Locale.en]: "/contact" as const,
} satisfies LocalizedString;

export function getContactPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
